module.exports = __webpack_public_path__ + "img/piaget-altiplano-ultimate-910p-6.a69a79d4.png";